module.exports = __webpack_public_path__ + "images/Headphone.6cc83ee1f9e6324b004af3e2e5dfcc0d.svg";